'use client';

// import LocaleSwitcher from '@/components/ui/local-switcher';
import LanguageBottomSheet from '@/components/ui/local-switcher/LanguageBottomSheet';
import useLogout from '@/hooks/useLogout';
import { useSession } from 'next-auth/react';
import { useLocale, useTranslations } from 'next-intl';
import NextLink from '@/components/next-link';

const NavLinks = ({
  links,
  textColor = 'text-black',
  textValue = '',
  textValueColor = 'text-black',
  onClick,
  isLoading,
}) => {
  const t = useTranslations('common');
  const locale = useLocale();
  const logOut = useLogout();
  const { data: session } = useSession();
  if (links.data.every((item) => item.requireAuth && !session)) return;
  return (
    <div className=''>
      <h5 className='ms-1 p-[9px] text-sm font-bold text-[#6b7280]'>
        {t(links.header)}
      </h5>

      <div className='border-border mx-3 rounded-[10px] border text-[12px] font-bold shadow-[0_6px_20px_rgba(2,8,23,0.06)]'>
        {links.data.map((item, index) => {
          if (item.requireAuth && !session) return;

          // If it's the language switcher, render it differently
          if (item.is_lang) {
            return (
              <div key={index} className={`p-3 ${item.bgColor}`}>
                <LanguageBottomSheet>
                  {/* Pass the entire row's content as children */}
                  <>
                    <span
                      className={`flex items-center ${textColor} gap-[9px] text-center`}
                    >
                      <span
                        className={`flex h-9 w-9 items-center justify-center rounded-[10px] border border-[#eceff3] ${item.bgColor ?? 'bg-[#f8fafc]'} p-1.5`}
                      >
                        <item.Icon className='h-[18px] w-[18px] opacity-[0.9]' />
                      </span>
                      <span className='flex flex-col items-start gap-0.5 text-sm font-medium'>
                        {t(item.title)}
                      </span>
                    </span>
                    <span
                      className={`opacity-[0.35] ${textColor} ${locale === 'ar' ? 'rotate-180' : ''}`}
                    >
                      ➔
                    </span>
                  </>
                </LanguageBottomSheet>
              </div>
            );
          }

          // Otherwise, render the normal link
          return (
            <div
              key={index}
              className={` ${index === links.data.length - 1 ? '' : 'border-border border-b'} p-3 ${item.bgColor}`}
            >
              <NextLink
                href={item.href ?? ''}
                target={item?.target || '_self'}
                className='flex w-full items-center justify-between'
                onClick={(e) => {
                  if (!item.href) {
                    e.preventDefault();
                    if (item?.title === 'Log Out') {
                      logOut();
                    }
                  }
                  onClick?.();
                }}
              >
                <span
                  className={`flex items-center ${textColor} gap-[9px] text-center`}
                >
                  <span
                    className={`flex h-9 w-9 items-center justify-center rounded-[10px] border border-[#eceff3] ${item.bgColor ?? 'bg-[#f8fafc]'} p-1.5`}
                  >
                    <item.Icon className='h-[18px] w-[18px] opacity-[0.9]' />
                  </span>
                  <span className='flex flex-col items-start gap-0.5 text-sm font-medium'>
                    {t(item.title)}
                    <span className='text-[13px] font-medium text-[#6b7280]'>
                      {item.subTitle && t(item.subTitle)}
                    </span>
                  </span>
                </span>

                {textValue && !item.notShowTextValue ? (
                  isLoading ? (
                    <LoadingSkeleton />
                  ) : (
                    <span
                      className={`${textValueColor} flex items-center gap-1`}
                    >
                      {textValue?.[item?.title]}
                    </span>
                  )
                ) : (
                  <span
                    className={`opacity-[0.35] ${textColor} ${locale === 'ar' ? 'rotate-180' : ''}`}
                  >
                    ➔
                  </span>
                )}
              </NextLink>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NavLinks;

const LoadingSkeleton = () => {
  return <div className='h-5 w-10 animate-pulse rounded-sm bg-gray-300' />;
};
